import React from "react"
import TableInputForecast from "./table-input-forecast/TableInputForecast.jsx"
import TargetForecastSubRegional from "./TargetForecastSubRegional.jsx"

export default function SettingForecastPage() {
  return (
    <div>
      <TargetForecastSubRegional />
      <TableInputForecast />
    </div>
  )
}
